import axios from "axios";

import ExportsApi from './Exports'
import FilesApi from './Files'
import ImportsApi from './Imports'
import DepositApi from  './Deposits'

const axiosHelpers = require('axios-helpers')
let api = axiosHelpers(axios.create({
    baseURL: 'https://importer.hexeko.com/api',
    crossdomain: true,
    timeout: 100000,
}))

api.exports = ExportsApi;
api.files = FilesApi;
api.imports = ImportsApi;
api.deposits = DepositApi;

export default api
